export default __webpack_public_path__ + "static/media/you-lose-home.83028aae.png";